import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonSpinner } from '@ionic/angular/standalone';

export type CrowdctrlLoadingCardLayout = 'page' | 'panel';

@Component({
  selector: 'crowdctrl-loading-card',
  standalone: true,
  imports: [CommonModule, IonSpinner],
  templateUrl: './loading-card.component.html',
  styleUrl: './loading-card.component.css',
})
export class LoadingCardComponent {
  /** Sole / primary content: fill viewport under header (default). Nested segment/card: use `panel`. */
  @Input() layout: CrowdctrlLoadingCardLayout = 'page';

  @Input() message?: string;

  @HostBinding('class.loading-card--panel')
  get isPanelLayout(): boolean {
    return this.layout === 'panel';
  }
}
